import { RootState } from '@shared/store';

export const selectors = {
  getAccessToken: (state: RootState) => state.auth.accessToken,
  getUser: (state: RootState) => state.auth.authenticatedUser,
  getAuthenticatedUserCompany: (state: RootState) => state.auth.authenticatedUserCompany,
  getSuperAdminAccessToken: (state: RootState) => state.auth.superAdminAccessToken,
};
